import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { ProtectedRoute } from "@/components/common/ProtectedRoute";
import { trackPageView } from "@/lib/analytics";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import ProductCategories from "@/pages/ProductCategories";
import StartYourBrand from "@/pages/StartYourBrand";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Videos from "@/pages/Videos";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Tools from "@/pages/Tools";
import CountryLanding from "@/pages/CountryLanding";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientDashboard from "@/pages/ClientDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackPageView(pathname); }, [pathname]);
  return null;
}

const withLayout = (el) => <SiteLayout>{el}</SiteLayout>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ScrollToTop />
            <PageTracker />
            <Routes>
            <Route path="/" element={withLayout(<Home />)} />
            <Route path="/about" element={withLayout(<About />)} />
            <Route path="/services" element={withLayout(<Services />)} />
            <Route path="/services/:slug" element={withLayout(<ServiceDetail />)} />
            <Route path="/industries" element={withLayout(<Industries />)} />
            <Route path="/products" element={withLayout(<ProductCategories />)} />
            <Route path="/start-your-brand" element={withLayout(<StartYourBrand />)} />
            <Route path="/blog" element={withLayout(<Blog />)} />
            <Route path="/blog/:slug" element={withLayout(<BlogPost />)} />
            <Route path="/videos" element={withLayout(<Videos />)} />
            <Route path="/case-studies" element={withLayout(<CaseStudies />)} />
            <Route path="/case-studies/:slug" element={withLayout(<CaseStudyDetail />)} />
            <Route path="/resources" element={withLayout(<Resources />)} />
            <Route path="/contact" element={withLayout(<Contact />)} />
            <Route path="/tools" element={withLayout(<Tools />)} />
            <Route path="/import/:country" element={withLayout(<CountryLanding />)} />

            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" richColors />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
